module.exports = __webpack_public_path__ + "media/images/flags/om-f0e56e84434d8300a43a09ac019c1d17.svg";